import { Component, ElementRef, OnInit, ViewChild, ViewChildren, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ICheckbox, IColumnchooser, IColumnHiding, IColumns, IEditing, IExportExcel, IGridOptions, IScroll, ISearchPanel, ProductoServicio, Toolbar, UnidadMedida } from 'app/interfaces';
import { CoalService } from 'app/services/coal.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectOperacionState,selectPermisosState,selectUtilsState} from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { ExcepcionesComponent } from 'app/utilerias/excepciones/excepciones.component';
import * as XLSX from 'xlsx';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import saveAs from 'file-saver';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ProductoAddComponent } from 'app/utilerias/producto-add/producto-add.component'
import {Router} from '@angular/router';

export interface PeriodicElement {
  position: string;
  nombre: string;
  tasa: number;
  monto: number;
  typo: string;
}

export interface PeriodicElement2 {
  numero_Pedimento: number;
  position: number;
}

const datosTabla1: PeriodicElement[] = [

];

const datosTabla2: PeriodicElement2[] = [

];


@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})


export class ProductoComponent implements OnInit {
  tasaa = new FormControl([Validators.pattern]);
  private dataReportSubject: BehaviorSubject<any[]> = new BehaviorSubject<
        any[]
    >([]);
    public dataReport$ = this.dataReportSubject.asObservable();

  // unidades de medida
  unidadMedida: UnidadMedida[] = [];
  filteredUnidadMedida: Observable<UnidadMedida[]>;
  getStateOperacion: Observable<any>;

  productoForm: FormGroup;
  randomElementIndex2: number
  randomElementIndex1: number

  options: ProductoServicio[] = [];
  filteredOptions: Observable<ProductoServicio[]>;
  myControl = new FormControl();
  myControlUnidadMedida = new FormControl();
  @ViewChild('datosTabla1') datosTabla1: MatTable<PeriodicElement>;
  @ViewChild('datosTabla2') datosTabla2: MatTable<PeriodicElement2>;
  delete: number;
  delete2: number;
  index: number = 0;
  index2: number = 0;

  gridOptions: IGridOptions;
  columns: IColumns[];
  exportExcel: IExportExcel;
  searchPanel: ISearchPanel;
  scroll: IScroll;
  toolbar: Toolbar[];
  columnHiding: IColumnHiding;
  Checkbox: ICheckbox;
  Editing: IEditing;
  Columnchooser: IColumnchooser;
  objetoGridConfiguration: any;
  objetosSelected: any;

  numeroPedimento: number = 0;
  nombre: string = '';
  tasa: number = 0
  monto: number = null
  typo: string = ''
  mostrar = true;
  lstIva: any;
  lstIva_retenido: any;
  lstIeps: any;
  lstIsr: any;

  idOperacion: number;
  ArrayImpuestosLocales = [];
  arreglo: any;
  a: any;
  lstDataReport = [];
  dataReport = [];
  idTipoReporteSel: number = 1;
  data: any;
  datosevent: any;
  verGrid: boolean = false;
  evento: any;
  idRoll = 2;
  mostrarControl = false;
  mostrarAddProducto = false;
  descargarExcel = true;
  displayedColumns: string[] = ['position', 'nombre', 'tasa', 'monto', 'typo'];
  dataSource1 = [{ position: '', nombre: '', tasa: 0, monto: 0, typo: '' }];

  displayedColumns2: string[] = ['position', 'nombre'];
  dataSource2 = [{ position: 0, numero_Pedimento: 0 }];

  mostrarAddCarga = false;
  contadorCargaMasiva = 0;
  lstTipoImpuesto: any;
  opcionSeleccionado = ''
  datosEventProducto: any;
  lstProducto: any = [];
  tituloFile
  arrayBuffer: any;
  spinner: boolean = false;
  dataActualizacion: any = [];
  modificarDatos: boolean = false;
  // @ViewChild('nombre') input: ElementRef<HTMLInputElement>;

  selectedTab = 0;
  rowsetshowClave: boolean  = false;
  rowsetshowUnidad: boolean = false;
  mostrarIvaRet: boolean    = false;
  errorNaN: boolean         = false;
  isValidUnidad: boolean    = true;
  isValidClave: boolean     = true;
  nombreReporte:string = '';
  getStateUtils: Observable<AppState>;
  idEmpresa: any;
  configured: boolean = null;

  constructor(private fb: FormBuilder,
    public dialog: MatDialog,
    //private readonly store: Store<AppState>,
    private srvcoal: CoalService,
    private _snackBar: MatSnackBar,
    private renderer: Renderer2,
    private router: Router,
    private store: Store,
  ) { 
    this.store.select(selectUtilsState).subscribe((state: any) => {
      if( state.empresaSeleccionada === undefined ){
        this.configured = false;
      }
      else{
        this.configured = true;
        if(this.idEmpresa !== state.empresaSeleccionada.id){
          this.idEmpresa = state.empresaSeleccionada.id;
          this.GetProducto();
        }
      }
  });

    this.dataReport$.subscribe((nuevosDatos) => {
      this.dataReport = nuevosDatos;
  });
  }

  ngOnInit(): void {

    this.modificarDatos = false;
    this.selectedTab = 0;
    this.dataSource1 = [];
    this.dataSource2 = [];
    // this.GetProducto();
    
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.claveDescripcion)),
      map(claveDescripcion => (claveDescripcion ? this._filter(claveDescripcion) : this.options.slice())),
    );

    this.filteredUnidadMedida = this.myControlUnidadMedida.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.claveNombre)),
      map(claveNombre => (claveNombre ? this._filterUnidadMedida(claveNombre) : this.unidadMedida.slice())),
    );
    this.formProducto();
    this.productoForm.controls.iepsCuota.disable();

    this.myControl.disable();
    this.myControlUnidadMedida.disable();

  }

  agregarProducto(): void {
    const dialogRef = this.dialog.open(ProductoAddComponent, {
      width: '800px',
      disableClose: true,
      data: {mode: 1, producto: null,idEmpresa:this.idEmpresa},
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
      if( result.success == 1 ){
        const productoExistente = this.dataReport.find(
          (producto) => producto.id === result.producto.id
      );
      if (productoExistente) {
          Object.assign(productoExistente, result.producto);
      } else {
          this.dataReport.push(result.producto);
      }
      this.dataReportSubject.next(this.dataReport);
      // console.log('result', result);

        ///this.GetProducto();
      }
    });
  }

  EliminaProductoPorOperacion() {
    if (this.dataReport.length === 0)
      return this._snackBar.open("No hay registros que eliminar", 'Ok', { duration: 10000 });
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea eliminar este registro?' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(MostrarSpinner())
        //console.log(this.dataReport);
        let body = {
          idOperacion: this.idOperacion,
        }
        this.srvcoal.postService("catalogo/PostDelProductoPorOperacion", body).subscribe(
          (res: any) => {
            if (res.err) {
              this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else {
              this._snackBar.open(res.recordsets[0][0].mensaje, 'ok', { duration: 3000 });
              this.GetProducto();
              this.mostrarAddCarga = false;
            }
          }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            //this.store.dispatch(OcultarSpinner());;
          }
        );
      } else {
        this._snackBar.open('Eliminacion cancelada', 'OK', { duration: 3000 });
        //this.store.dispatch(OcultarSpinner());;
      }
    });

  }

  DescargarPlantilla() {
    const workbook = new ExcelJS.Workbook();
    const general = workbook.addWorksheet('PlantillaProducto');
    let columnas = ['Codigo', 'Nombre', 'Descripcion', 'Unidad', 'Precio', 'UnitCode', 'CodeProdServ', 'Agregado', 'Errores']
    let headerRow = general.addRow(columnas);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D3D3D3' },
        bgColor: { argb: 'FF0000FF' }
      };
      cell.font = {
        size: 11,
        bold: true
      };
    });
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Plantilla Productos' + '-' + new Date().valueOf() + '.xlsx');
    });

  }

  importExcel($event) {
    this.lstProducto = [];
    let file = ($event.target as HTMLInputElement).files[0];
    if (file === undefined) {
      this.tituloFile = "Seleccione un archivo";
      this._snackBar.open("Favor de seleccionar un archivo válido", 'Ok', { duration: 10000 });
      // this.spinner = false;
    } else {
      this.tituloFile = file.name;
      if (file.name.toLowerCase().indexOf(".xlsx") > 0 || file.name.toLowerCase().indexOf(".xls") > 0) {
        this.xlsxToJSON(file);
      }
      else {
        this._snackBar.open("Favor de seleccionar un archivo válido", 'Ok', { duration: 10000 });
        // this.spinner = false;
      }
    }
  }

  xlsxToJSON(event) {
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(event);
    fileReader.onload = async (e) => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = new Array();
      for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      let bstr = arr.join("");
      let workbook = XLSX.read(bstr, { type: "binary" });
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      let arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.lstProducto = arraylist;
      this.lstProducto.array.forEach(x => {
        x.Nombre = x.Nombre.toUpperCase();
        x.Descripcion = x.Descripcion.toUpperCase();
      });
      this._snackBar.open("Carga de datos completa", 'Ok', { duration: 10000 });
      // this.spinner = false;
      //console.log('datos del excel', this.lstProducto)
    }
  }

  procesarArchivo() {
    if (this.lstProducto.length === 0)
      return this._snackBar.open("Favor de cargar un archivo", 'Ok', { duration: 10000 });
    let xmlProducto = `<propiedades>`
    this.lstProducto.forEach(e => {
      xmlProducto += `<propiedad><Codigo>${e.Codigo}</Codigo><Nombre>${e.Nombre}</Nombre><Descripcion>${e.Descripcion}</Descripcion><Unidad>${e.Unidad}</Unidad><Precio>${e.Precio}</Precio><UnitCode>${e.UnitCode}</UnitCode><CodeProdServ>${e.CodeProdServ}</CodeProdServ><Agregado>${e.Agregado}</Agregado><Errores>${e.Errores}</Errores></propiedad>`;
    });
    xmlProducto += `</propiedades>`;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea registrar estos productos?' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(MostrarSpinner())
        //console.log(this.dataReport);
        let body = {
          idRol: 2,
          idOperacion: this.idOperacion,
          XMLProductoTemplate: xmlProducto
        }
        this.srvcoal.postService("catalogo/PostINSProductoTemplate", body).subscribe(
          (res: any) => {
            if (res.err) {
              this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else {
              this._snackBar.open(res.recordsets[0][0].mensaje, 'ok', { duration: 3000 });
              this.GetProducto();
              this.lstProducto.length = 0;
              this.mostrarAddCarga = false;
            }
          }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            //this.store.dispatch(OcultarSpinner());;
          }
        );
      } else {
        this._snackBar.open('Proceso cancelado', 'OK', { duration: 3000 });
        //this.store.dispatch(OcultarSpinner());;
        this.lstProducto.length = 0;
      }
    });
  }

  private _filter(value: string): ProductoServicio[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.claveDescripcion.toLowerCase().includes(filterValue));
  }

  private _filterUnidadMedida(value: string): UnidadMedida[] {
    const filterValueUnidad = value.toLowerCase();
    return this.unidadMedida.filter(option => option.claveNombre.toLowerCase().includes(filterValueUnidad));
  }

  GetSelProductoServicio(event, accion) {
    const descripcion = accion === 0 ? event.target.value : event;
    if(descripcion.length < 4 ){
      this._snackBar.open('Favor de ingresar al menos 4 caracteres', 'OK', { duration: 5000 });

      return false;
    }

    this.myControl.enable();

    this.store.dispatch(MostrarSpinner())
    if (descripcion != null || descripcion != '') {
      
      this.srvcoal.getService(`clave-sat/find?descripcion=${descripcion}`).subscribe((res: any) => {
      //this.srvcoal.getService(`catalogo/GetSelProductoServicio?descripcion=${descripcion}`).subscribe((res: any) => {
        this.store.dispatch(OcultarSpinner());
        if (res.err) {
          this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
        } else {
          this.options = res.data

          if( res.recordsets[0].length == 0 ){
            this._snackBar.open('No se encontraron resultados con tu busqueda, favor de intentar nuevamente.', 'OK', { duration: 5000 });
          }
          else{
            this.rowsetshowClave = true;
            // myInputClave
            setTimeout(() => {
              // this.myInputClave.nativeElement.focus();
              var element = this.renderer.selectRootElement('#myInputClave');
              element.focus();
            }, 500);
          }

          ////console.log('servicio', this.options)
        }
      }, (error: any) => {
        //this.store.dispatch(OcultarSpinner());
        this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
      });
    } else {
      //this.store.dispatch(OcultarSpinner());
    }
  }

  onSearchChange(value: any){
    if( Number.isNaN( parseFloat( value ) ) ){
      if( value.toString().length == 0 ){
        this.errorNaN = false;
      }
      else{
        this.errorNaN = true;
      }
    }
    else{
      if( value.toString().length == 0 ){
        this.mostrarIvaRet = false;
      }
      else{
        if( value < 0 ){
          this.errorNaN = true;
        }
        else{
          this.errorNaN = false;
          this.mostrarIvaRet = true;
          this.productoForm.controls.ivaRet.setValue(0);
        }
      }
    }
  }

  addProducto() {
    this.mostrarAddProducto = true;
    this.mostrarAddCarga = false;
  }

  cerrarAddProducto() {
    this.mostrarAddProducto = false;
    this.mostrarAddCarga = false;
    this.modificarDatos = false;
    this.productoForm.reset();
    this.dataSource1 = [];
    this.dataSource2 = [];
    this.myControl.reset();
    this.myControlUnidadMedida.reset();
    this.productoForm.controls.tasa.setValue(true);
    this.selectedTab = 0;
  }

  addCargaMasiva() {
    this.contadorCargaMasiva++;
    if (this.contadorCargaMasiva % 2) {
      //console.log('con ++', this.contadorCargaMasiva)
      this.mostrarAddCarga = true
    } else {
      this.mostrarAddCarga = false
    }
  }


  formProducto() {
    this.productoForm = this.fb.group({
      nomInterno: new FormControl('', Validators.required),
      noIdentificacion: new FormControl(),
      precioUnitario: new FormControl('', Validators.required),
      cuentaPredial: new FormControl(),
      descripcion: new FormControl('', Validators.required),
      iva: new FormControl(),
      ivaRet: new FormControl(),
      tasa: new FormControl(true),
      cuota: new FormControl(),
      iepsCuota: new FormControl(),
      iepsTasa: new FormControl(),
      isr: new FormControl(),
    })
  }


  GetProducto() {
    this.store.dispatch(MostrarSpinner());
    this.verGrid = false;
    this.dataReport.length = 0;
    this.lstDataReport.length = 0;
    this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[pro_productos][populate][cat_clave_sat][populate]=*
    &populate[pro_productos][populate][cat_iep][populate]=*
    &populate[pro_productos][populate][cat_isr][populate]=*
    &populate[pro_productos][populate][cat_iva][populate]=*
    &populate[pro_productos][populate][cat_iva_ret][populate]=*
    &populate[pro_productos][populate][cat_objeto_impuesto][populate]=*
    &populate[pro_productos][populate][cat_unidad][populate]=*
    &populate[pro_productos][populate][pro_cuenta_predials][populate]=*
    &populate[pro_productos][populate][pro_pedimentos][populate]=*
    &populate[pro_productos][populate][pro_impuesto_locals][populate]=*&fields[0]=rfc`,).subscribe((res: any) => {
    // this.srvcoal.getService(`pro-productos?populate=*`,).subscribe((res: any) => {
        if (res.err) {
          this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
        } else {
          this.dataReport = res.data[0].attributes.pro_productos.data
          this.ObjectGrid();
        }
      }, (error: any) => {
        console.log("erro *************** 3",error)
        this.store.dispatch(OcultarSpinner());
        this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))

      });
  }

  ObjectGrid() {
    let that = this;
    this.nombreReporte = 'Productos';
    this.objetoGridConfiguration = {
      GridOptions: {
        paginacion: 20,
        pageSize: [
          '40',
          '60',
          '80',
          '100'
        ]
      },
      ExportExcel: { enabled: true, fileName: 'Historico' },
      ColumnHiding: { hide: true },
      Checkbox: { checkboxmode: 'single' },
      Editing: { allowupdate: true, mode: 'cell' },
      Columnchooser: { columnchooser: true },
      SearchPanel: { visible: true, width: 200, placeholder: 'Buscar...', filterRow: true },
      Scroll: { mode: 'infinite' },
      Color: null,
      Detail: { detail: true },
      ToolbarDetail: null,
      ToolBox: [
        {
          location: 'after',
          widget: 'dxButton',
          locateInMenu: 'auto',
          options: {
              width: 60,
              onClick: this.modificar.bind(this),
              icon: '../../../assets/icons/ver.png',
          },
          visible: true,
          name: 'simple'
    }, {
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
          width: 60,
          icon: '../../../assets/icons/borrar.png',
          onClick: this.EliminarProducto.bind(this)
      },
      visible: true,
      name: 'simple'
}
      ],
      Columns: [],
      Data: [],
      Columns1: [1],
      Data1: [],
      datosMessage(evento) {
        that.objetosSelected = evento.data;
       
      }
    };
    this.DataColumnsGrid();
  };

  receiveMessage($event) {
    try {
        this.evento = $event.event;
        // console.log("misDATOS",this.datosevent)
    } catch (error) {
        // this.Excepciones(error, 1);
    }
  }
  modificar(e) {
    // console.log( "modificar(e)", this.datosevent );
    const dialogRef = this.dialog.open(ProductoAddComponent, {
      width: '800px',
      disableClose: true,
      data: {mode: 2, producto: this.datosevent},
    });

    dialogRef.afterClosed().subscribe(result => {
      if( result.success == 1 ){
        const productoExistente = this.dataReport.find(
          (producto) => producto.id === result.producto.id
      );
      if (productoExistente) {
          Object.assign(productoExistente, result.producto);
      } else {
          this.dataReport.push(result.producto);
      }
      this.dataReportSubject.next(this.dataReport);
      }
    });
  }

  cargarAutocomplete(e) {
    let indexProducto
    indexProducto = this.options.findIndex(x => x.idProducto === e.claveProdServ)
    this.myControl.setValue(this.options[indexProducto]);
    let indexUnidades
    indexUnidades = this.unidadMedida.findIndex(x => x.idUnidad === e.claveUnidadMedida)
    this.myControlUnidadMedida.setValue(this.unidadMedida[indexUnidades]);
  }

  invocarEventoCliente(e): void {
    this.mostrarAddProducto = false;
    //console.log('e', e);
  }

  EliminarProducto(e) {
    console.log(e, `EliminarProducto`);
    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea eliminar este registro?' });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("console datos event",this.datosevent)
        this.store.dispatch(MostrarSpinner())
        let idProducto = this.datosevent.id
        
        this.srvcoal.deleteService(`pro-productos/${idProducto}`).subscribe(
          (res: any) => {
            if (res.err) {
              this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            }
            else {
              const productoIndex = this.dataReport.findIndex(producto => producto.id === idProducto);
              this.dataReport.splice(productoIndex, 1);
              this._snackBar.open("Se ha eliminado con exito", 'ok', { duration: 3000 });
              this.store.dispatch(OcultarSpinner());;
            }
          }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner());
            this.spinner = false;
          }
        );
      } else {
        this._snackBar.open('Eliminacion cancelada', 'OK', { duration: 3000 });
        //this.store.dispatch(OcultarSpinner());;
        this.spinner = false;
      }
    });

  }

  DataColumnsGrid() {
    if (!this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel)) {
      let columnsMulti = [];
      columnsMulti.push({
        caption: 'Código SAT',
        dataField: 'attributes.cat_clave_sat.data.attributes.clave',
        allowEditing: false,
        fixed: true,
      });
      columnsMulti.push({
        caption: 'Nombre',
        dataField: 'attributes.nombre',
        allowEditing: false
      });
      columnsMulti.push({
        caption: 'Descripción',
        dataField: 'attributes.descripcion',
        allowEditing: false
      });
      columnsMulti.push({
        caption: 'Código de la Unidad',
        dataField: 'attributes.cat_unidad.data.attributes.clave',
        allowEditing: false
      });
      columnsMulti.push({
        caption: 'Unidad',
        dataField: 'attributes.cat_unidad.data.attributes.nombre',
        allowEditing: false,
      });
      columnsMulti.push({
        caption: 'Precio',
        dataField: 'attributes.precioUnitario',
        allowEditing: false,
        side : 'right',
        cellTemplate: function(container, options) {
          var precio = options.data.attributes.precioUnitario;
          var div = document.createElement('div');
          div.textContent = '$' + parseFloat(precio).toLocaleString('en-US');
          container.appendChild(div);
        }

      });
      // columnsMulti.push({
      //   caption: 'Acciones',
      //   dataField: 'accion',
      //   allowEditing: false,
      //   cellTemplate: 'templateBotones'
      // });
      setTimeout(() => this.lstDataReport.push({
        idTipoReporte: this.idTipoReporteSel,
        columnas: columnsMulti,
        dataReport: this.dataReport,
        identificadorGrid: 0
      }), 500);
      setTimeout(() => this.FillGrid(), 800);
    } else {
      this.FillGrid();
    }
  }

  FillGrid() {
    this.objetoGridConfiguration.Columns = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).columnas;
    this.objetoGridConfiguration.Data = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).dataReport;
    this.verGrid = true;
    this.store.dispatch(OcultarSpinner());
  }

  datosMessage($event) {
    try {
        console.log("soy",$event.data[0])
        this.datosevent = $event.data[0];
    } catch (error) {
        // this.Excepciones(error, 1);
    }
  }
  Excepciones(pila, tipoExcepcion: number) {
    try {
      const dialogRef = this.dialog.open(ExcepcionesComponent, {
        width: '60%',
        data: {
          idTipoExcepcion: tipoExcepcion,
          idUsuario: 1,
          idOperacion: 1,
          idAplicacion: 1,
          moduloExcepcion: 'sel-caja-historial.component',
          mensajeExcepcion: '',
          stack: pila,
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => { });
    } catch (error) {
      // console.error(error);
    }
  }

  getErrorMessage() {
    if (this.tasaa.hasError('pattern')) {
      return 'You must enter a value';
    }
    return 'You must enter a value';
  }

  cargaMasiva() {
    this.router.navigate(['/catalogos/carga-masiva-productos']);
  }

}
